export default __webpack_public_path__ + "static/media/AdormentIcon.893dfe83.svg";